import "./SpecimenDialogController.css";

import classNames from "classnames";
import { useState } from "react";

import { Specimen } from "pwapi";

import { CaseDetailState } from "shared/reducers/caseDetailReducer";
import { SlideDetailState } from "shared/reducers/slideDetailReducer";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "store/hooks";

import { DialogEnum } from "./Dialog";
import Sidebar from "./Sidebar";
import SpecimenDialog, { shouldShowSpecimenDialog } from "./SpecimenDialog";
import SpecimenDialogEditForm from "./SpecimenDialogEditForm";
import SlideBarcode from "../SlideBarcode";

export type SpecimenDialogProps = {
  specimen: Specimen;
  caseDetail?: CaseDetailState;
};

type ExtendedSpecimenDialogProps = SpecimenDialogProps & {
  slideDetailObject: SlideDetailState;
  dialog: DialogEnum | null;
};

const SpecimenDialogController = ({
  dialog,
  specimen,
  caseDetail,
  slideDetailObject,
}: ExtendedSpecimenDialogProps) => {
  const [editingSpecimen, setEditingSpecimen] = useState<boolean>(false);

  const macro_image_url = useAppSelector(
    ({ meta }) => meta.slides[slideDetailObject.id || 0]?.macro_image_url
  );
  const barcode_image_url = useAppSelector(
    ({ meta }) => meta.slides[slideDetailObject.id || 0]?.barcode_image_url
  );
  const slideMacroUnderSpecimen = useAppSelector((state) =>
    selectFeatureFlag(state, "slideMacroUnderSpecimen")
  );

  const showSpecimenDialog = shouldShowSpecimenDialog(specimen);

  return (
    <div className="SpecimenDialogController">
      <div className="Sidebar__parentContainer">
        {dialog === DialogEnum.Specimen && showSpecimenDialog && (
          <Sidebar isScrollable parent isWide={editingSpecimen}>
            <div className="Sidebar__contentContainer">
              {editingSpecimen ? (
                <SpecimenDialogEditForm
                  specimen={specimen}
                  caseDetail={caseDetail}
                  onClose={() => setEditingSpecimen(false)}
                />
              ) : (
                <SpecimenDialog
                  specimen={specimen}
                  onEdit={() => setEditingSpecimen(true)}
                  caseDetail={caseDetail}
                />
              )}
            </div>
          </Sidebar>
        )}
        <div
          className={classNames("SlideImages", {
            "SlideImages--Yosemite":
              slideDetailObject.url_path?.includes("yosemite-pathology"),
          })}
        >
          <SlideBarcode
            topLeft={slideMacroUnderSpecimen}
            barcode_image_url={barcode_image_url}
            macro_image_url={macro_image_url}
          />
        </div>
      </div>
    </div>
  );
};

export default SpecimenDialogController;
